<template>
  <v-autocomplete
    v-model="selectedOptions"
    :items="optionsToRender"
    item-text="label"
    return-object
    outlined
    multiple
    :dense="true"
    :label="filterQuestion.form_label"
    chips
    small-chips
    deletable-chips
  />
</template>

<script>
export default {
  name: 'FilterMultiSelect',

  data () {
    return {
      selectedOptions2: []
    }
  },

  props: {
    filterQuestion: {
      type: Object,
      required: true
    }
  },

  computed: {
    selectedOptions: {
      get () {
        let values = []
        this.questionKeys.forEach(key => {
          const answerValues = this.$store.getters['getFilterAnswer'](key) || []
          values = values.concat(answerValues.map(value => ({
            questionKey: key,
            label: value
          })))
        })
        return values
      },
      set (value) {
        // clear all questions_keys
        this.questionKeys.forEach(key => {
          this.$store.commit('setFilterAnswer', {
            questionKey: key,
            value: undefined
          })
        })
        // add Answer for each key
        value.forEach(val => {
          this.$store.commit('addFilterAnswer', {
            questionKey: val.questionKey,
            value: val.label
          })
        })
      }
    },
    questionKeys () {
      return this.optionsToRender.reduce((res, option) => {
        if (!res.includes(option.questionKey)) {
          res.push(option.questionKey)
        }
        return res
      }, [])
    },
    optionsToRender () {
      return this.filterQuestion.type.options
    }
  },

  methods: {
    isValueTypeValid (value) {
      return Array.isArray(value)
    }
  }
}
</script>
